<!--  -->
<template>
  <div>
    <div class="active_name">
      <div class="acwc_name">活动名称</div>
      <el-input v-model="activityname" v-model.trim="activityname" style="width:230px" placeholder="请输入内容" @input="activityname = activityname.replace(reg, '')" />
    </div>
    <div class="active_name">
      <div class="acwc_name">活动主题</div>
      <el-tag v-if="styleid !== null" size="medium" style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;">{{ stylename }}</el-tag>
      <el-button type="primary" @click="choosetheme"> 选择活动主题 </el-button>
    </div>
    <div class="active_name">
      <div class="acwc_name">购买章节数量</div>
      <el-input v-model="chapter" style="width:230px" placeholder="填写范围：1-200" />
      <el-button type="primary" style="margin:0 10px" @click="choosebookid"> 选择书籍 </el-button>
      <el-input v-model="bookname" disabled style="width:230px" placeholder="不选择将默认任意书籍" />
    </div>
    <div class="active_name">
      <div class="acwc_name">赠送书券数量</div>
      <el-input v-model="bookcertificate" style="width:230px" placeholder="填写范围：1-200" />
      <div class="acwc_name">赠送名额</div>
      <el-input v-model="freequota" style="width:230px" placeholder="填写范围：1-10000" />
    </div>
    <div class="active_name">
      <div class="acwc_name">期限选择</div>
      <el-select v-model="time_type" placeholder="请选择">
        <el-option
          v-for="item in timeoptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div v-if="time_type === 2" class="active_name">
      <div class="acwc_name">固定天数</div>
      <el-input v-model="appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="appoint_day = appoint_day.replace(/[^A-z0-9]/, '')" />
    </div>
    <div v-if="time_type === 1" class="active_name">
      <div class="acwc_name">活动时间</div>
      <el-date-picker
        v-model="timevalue"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        :clearable="false"
        style="width:430px"
        @change="timechanger"
      />
    </div>

    <div class="active_name">
      <div class="acwc_name">活动展示位</div>
      <div>
        <el-checkbox v-model="banner" :true-label="1" :false-label="0">阅读页banner</el-checkbox>
        <el-checkbox v-model="indexbanner" :true-label="1" :false-label="0">首页banner</el-checkbox>
        <el-checkbox v-model="centerbanner" :true-label="1" :false-label="0">活动中心</el-checkbox>
        <el-checkbox v-model="down" :true-label="1" :false-label="0">阅读页底部</el-checkbox>
      </div>
    </div>
    <div class="active_name">
      <div class="acwc_name">用户圈定</div>
      <div>
        <el-radio-group v-model="delineationradio">
          <div class="dada">
            <el-radio :label="0">任意用户：无门槛限制</el-radio>
          </div>
          <div class="dada">
            <el-radio :label="1">老用户：注册2天及以上的用户（排除48小时新用户）</el-radio>
          </div>
          <div class="dada">
            <el-radio :label="2">全量未充值用户（排除新用户）：注册2天及以上&从未充值用户</el-radio>
          </div>
          <div class="dada">
            <el-radio :label="3">1周未充值用户：注册7天及以上&7天内未充值用户</el-radio>
          </div>
          <div class="dada">
            <el-radio :label="4">2周未充值用户：注册14天及以上&14天内未充值用户</el-radio>
          </div>
        </el-radio-group>
      </div>
    </div>
    <div class="asdatw">
      <div class="explain">
        <div>说明：</div>
        <div>1.默认0点开始+24点结束，单次活动最多在线30天</div>
      </div>
      <div class="sdaraw">
        <div>2.活动时间内的购买都会计入活动购买进度（如8点配置上线当日0-24点的活动，当日0-8点未活动上线时的购买也会计入其中）</div>
        <div>3.阅读页底部同一时间仅展示一个活动</div>
        <div>4.书券奖励配置上限为阅读书籍章节数的10倍</div>
        <div>5.用户圈定仅限制活动运营位展示，不限制用户参与机会（即非标签范围内的用户不可见书城内该活动的运营位，但可通过链接参与该活动）。</div>
      </div>
    </div>
    <div class="ribbon_box">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
    >
      <chooseaccount ref="chooseviewr" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <themedialog ref="themeview" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import { acawraccountlist, readingservice } from '@/api/sourceMaterial.js'
import chooseaccount from '../../addsubset/components/chooseaccount.vue'
import themedialog from './themedialog.vue'
export default {
  components: {
    chooseaccount,
    themedialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      activityname: '', // 活动名称
      stylename: '',
      styleid: null, // 活动主题id
      chapter: '', // 购买章节
      bookname: '', // 书的名称
      bookid: '', // 书的id
      bookcertificate: '', // 书卷数量
      freequota: '', // 赠送名额
      timevalue: [], // 绑定开始结束时间的数组
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      startTime: '', // 活动开始时间
      endTime: '', // 活动结束时间
      delineationradio: 0, // 用户圈定 不用传此参数 只是展示
      dialogVisibler: false, // 书籍弹窗
      dialogVisible: false,
      theme: [],
      banner: 0,
      down: 0,
      indexbanner: 0,
      centerbanner: 0,
      appoint_day: '',
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {
    this.getactivry()
  },
  mounted() {

  },
  methods: {
    async getactivry() {
      // 获取主题
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 3
      })
      this.stylename = data.data.theme[0].description
      this.styleid = data.data.theme[0].value
      this.theme = data.data.theme
      console.log('data', data.data.theme[0].description, data.data.theme[0].value)
    },
    choosetheme() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(this.theme)
      })
    },
    close(item) {
      console.log('item', item)
      this.dialogVisible = false
      this.stylename = item.description
      this.styleid = item.value
    },
    callback(item) {
      console.log('item 选择完书籍的回调', item)
      this.bookname = item.book_title
      this.bookid = item.book_id
      this.dialogVisibler = false
      // 选择完书籍的回调
    },
    choosebookid() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chooseviewr.send(this.platformid)
      })
    },
    timechanger(val) {
      console.log('val', this.timevalue)
      this.startTime = this.timevalue[0]
      this.endTime = this.timevalue[1]
    },
    cancel() {
      this.$emit('close')
    },
    async determine() {
      if (this.activityname === '') {
        this.$message.error('请输入活动名称')
        return
      }
      if (this.chapter === '') {
        this.$message.error('请输入购买章节数量')
        return
      }
      if (this.bookid === '') {
        this.$message.error('请选择书籍')
        return
      }
      if (this.bookcertificate === '') {
        this.$message.error('请输入赠送书券数量')
        return
      }
      if (this.freequota === '') {
        this.$message.error('请输入赠送名额')
        return
      }
      // if (this.startTime === '' && this.endTime === '') {
      //   this.$message.error('请选择活动开始时间')
      //   return
      // }
      if (this.time_type === 1) {
        if (this.startTime === '' && this.endTime === '') {
          this.$message.error('请选择活动开始时间')
          return
        }
      } else {
        if (this.appoint_day === '') {
          this.$message.error('固定期限不能为空')
          return
        }
        if (this.appoint_day.length > 3) {
          this.$message.error('固定天数不能超过3位')
          return
        }
      }
      const par = {}
      if (this.time_type === 1) {
        par.time_type = this.time_type
        par.start_time = this.startTime
        par.end_time = this.endTime
      } else {
        par.time_type = this.time_type
        par.appoint_day = Number(this.appoint_day)
      }
      const data = await readingservice({
        ...par,
        platform_id: this.platformid,
        activity_type: 3,
        activity_info: {
          acname: this.activityname, // 活动名称
          tpl: this.styleid,
          once: this.bookcertificate,
          totalGift: this.freequota,
          unlock: this.chapter,
          cbid: this.bookid,
          banner: this.banner, // 阅读页banner
          indexbanner: this.indexbanner, // 首页banner
          centerbanner: this.centerbanner, // 活动中心
          down: this.down, // 阅读页底部
          // start_time: this.startTime,
          // end_time: this.endTime,
          user_filte: this.delineationradio
        }
      })
      this.$message({
        type: 'success',
        message: '添加成功!'
      })
      this.$emit('close')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.active_name{
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.acwc_name{
  margin-right: 10px;
  width: 90px;
  text-align: right;
}
.dada{
  margin-bottom: 10px;
}
.asdatw{
    font-size: 13px;
    line-height: 30px;
    color: #bbb;
        margin-left: 8px;
        margin-top: 10px;
}
.explain{
  display: flex;
  align-items: center;
}
.sdaraw{
  margin-left: 40px;
}
.ribbon_box{
  margin-top: 40px;
  text-align: right;
}
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button {
-webkit-appearance: none;
 }
::v-deep .el-input__inner[type='number'] {
-moz-appearance: textfield;
 }

 @media (max-width: 768px) {
  .asdatw,
  .acwc_name ,.el-radio__label{
    font-size: 2.8vw;
  }
  .el-radio-group .dada .el-radio__label {
    font-size: 2.8vw !important;
  }
}
</style>
